export default [
    "24 24",
    '<path id="Vector" d="M8 14L12 10L16 14" fill="none" stroke="var(--ci-primary-color, currentColor)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
]

